import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  url: `${process.env.REACT_APP_KEYCLOAK_URL}/`,
  realm: "eventool",
  clientId: "eventool-app",
});

const setToken = () => {
};

keycloak.onAuthSuccess = setToken;
keycloak.onAuthRefreshSuccess = setToken;

export default keycloak;
